import React from 'react';
import { st, classes } from './GooglePreview.st.css';
import { DEFAULT_TOOLTIP_PROPS, dataHooks } from './constants';

import Text from '../Text';
import { GooglePreviewProps } from './GooglePreview.types';

import { GooglePreviewWebsiteInfo } from './components/GooglePreviewWebsiteInfo';

const GooglePreview = ({
  dataHook,
  previewUrl,
  title,
  description,
  titleMaxLines = 1,
  descriptionMaxLines = 2,
  skin = 'light',
  siteName,
  favicon,
  websiteInfoTooltipContent,
  websiteInfoTooltipProps,
  onTitleMouseEnter = () => {},
  onTitleMouseLeave = () => {},
  onDescriptionMouseEnter = () => {},
  onDescriptionMouseLeave = () => {},
  onWebsiteInfoClick = () => {},
  onTitleClick = () => {},
  onDescriptionClick = () => {},
}: GooglePreviewProps) => (
  <div
    className={st(classes.root, {
      transparent: skin === 'transparent',
    })}
    data-hook={dataHook}
  >
    <GooglePreviewWebsiteInfo
      previewUrl={previewUrl}
      siteName={siteName}
      favicon={favicon}
      onClick={onWebsiteInfoClick}
      tooltipContent={websiteInfoTooltipContent}
      tooltipProps={websiteInfoTooltipProps}
    />
    <Text
      className={classes.googlePreviewTitle}
      dataHook={dataHooks.GooglePreviewTitle}
      weight="thin"
      size="tiny"
      secondary={false}
      light={false}
      ellipsis
      tooltipProps={DEFAULT_TOOLTIP_PROPS}
      maxLines={titleMaxLines}
      onMouseEnter={onTitleMouseEnter}
      onMouseLeave={onTitleMouseLeave}
      onClick={onTitleClick}
    >
      {title}
    </Text>
    <Text
      className={classes.googlePreviewDescription}
      weight="thin"
      size="tiny"
      light={false}
      dataHook={dataHooks.GooglePreviewDescription}
      ellipsis
      tooltipProps={DEFAULT_TOOLTIP_PROPS}
      maxLines={descriptionMaxLines}
      onMouseEnter={onDescriptionMouseEnter}
      onMouseLeave={onDescriptionMouseLeave}
      onClick={onDescriptionClick}
    >
      {description}
    </Text>
  </div>
);

GooglePreview.displayName = 'GooglePreview';

export default GooglePreview;
